import React, { useState, useEffect, useMemo } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { GatsbyImage } from "gatsby-plugin-image";


import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { ReferenciaPlantillaContenido } from "../../../interfaces/ReferenciaPlantillaContenido";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import Button from "../../atoms/button/button";
import {
  normalizeTwoWords,
  findTarget,
  findRel,
  formatImageAlt
} from "../../../shared/utils/stringUtilities";

import "./galleryExtended.scss";

const GalleryExtended = (props: ReferenciaContenido) => {
  const { isBrowser, window } = useBrowserMode();
  const [content, setContent] = useState<ReferenciaPlantillaContenido[]>([]);
  const [pager, setPager] = useState<number>(0);
  const [limit, setLimit] = useState<number>(6);
  const isMoreSix = props.referenciaPlantillaContenido.length > limit;

  useEffect(() => {
    change();
    isBrowser && window.addEventListener("resize", change);
    return () => window.removeEventListener("resize", change);
  }, []);

  useMemo(() => reset(), [limit]);

  function change() {
    if (isBrowser) {
      setLimit(window.screen.width <= 960 ? 3 : 6);
    }
  }

  function reset() {
    setContent(
      isMoreSix
        ? props.referenciaPlantillaContenido.slice(0, limit)
        : props.referenciaPlantillaContenido
    );
    setPager(limit);
  }

  const getMore = () => {
    setContent(
      content.concat(
        props.referenciaPlantillaContenido.slice(pager, pager + limit)
      )
    );
    setPager(pager + limit);
  };

  return (
    <div className="o-gallery-extended">
      <span className="o-gallery-extended__title">{props.tituloGeneral}</span>
      <div className="o-gallery-extended__container">
        {content.map((value, index) => (
          <a
            key={index}
            className={`o-gallery-extended__container__item gtm${normalizeTwoWords(
              props.nombreCategoria
            )}${normalizeTwoWords(props.tituloGeneral)}${normalizeTwoWords(
              value.tituloBanner
            )}${index}`}
            rel={findRel(value.redireccionBoton)}
            href={value.redireccionBoton}
            title={value.tituloBanner}
            target={findTarget(value.redireccionBoton)}
          >
            {value.imagenPrincipal && (
              value.imagenPrincipal[0].gatsbyImageData ?
                <GatsbyImage
                  className={`o-gallery-extended__container__item__img gtm${normalizeTwoWords(
                    props.nombreCategoria
                  )}${normalizeTwoWords(props.tituloGeneral)}${normalizeTwoWords(
                    value.tituloBanner
                  )}${index}`}
                  image={value.imagenPrincipal[0].gatsbyImageData}
                  alt={value.imagenPrincipal[0].title 
                    ? formatImageAlt(value.imagenPrincipal[0].title) 
                    : `Imagen ${value.tituloBanner}`
                  }
                />
                :
                <img
                  className={`o-gallery-extended__container__item__img gtm${normalizeTwoWords(
                    props.nombreCategoria
                  )}${normalizeTwoWords(props.tituloGeneral)}${normalizeTwoWords(
                    value.tituloBanner
                  )}${index}`}
                  src={value.imagenPrincipal[0].file.url}
                  alt={value.imagenPrincipal[0].title 
                    ? formatImageAlt(value.imagenPrincipal[0].title) 
                    : `Imagen ${value.tituloBanner}`
                  }
                />
            )}
            <div
              className={`o-gallery-extended__container__item__box gtm${normalizeTwoWords(
                props.nombreCategoria
              )}${normalizeTwoWords(props.tituloGeneral)}${normalizeTwoWords(
                value.tituloBanner
              )}${index}`}
            >
              <span
                className={`o-gallery-extended__container__item__box__title gtm${normalizeTwoWords(
                  props.nombreCategoria
                )}${normalizeTwoWords(props.tituloGeneral)}${normalizeTwoWords(
                  value.tituloBanner
                )}${index}`}
              >
                {value.tituloBanner}
              </span>
              {value.descripcion && (
                <article className="o-gallery-extended__container__item__box__text">
                  {documentToReactComponents(value.descripcion.json)}
                </article>
              )}
            </div>
          </a>
        ))}
      </div>
      {props.referenciaPlantillaContenido.length > pager && (
        <button className="o-gallery-extended__button" onClick={getMore}>
          Ver más
        </button>
      )}
      {content.length >= props.referenciaPlantillaContenido.length &&
        props.tituloBoton && (
          <Button
            classname={"o-gallery-extended__button"}
            gtmMark={`gtm${normalizeTwoWords(
              props.nombreCategoria
            )}${normalizeTwoWords(props.tituloBoton)}`}
            type={"link"}
            target={"_self"}
            strictCss={true}
            isDisabled={false}
            text={props.tituloBoton}
            href={props.redireccionBoton}
          />
        )}
    </div>
  );
};

export default GalleryExtended;
